<template>
  <div class='feedbackPageContainer' ref='feedback_page'>
    <modals-container/>
      <div class='PageHeader'>
        <div class='PageHeaderRollsRoyceLogo'></div>
        <div class='PageHeaderTitleContainer'>Feedback</div>
        <div class='PageHeaderButtonContainer'>
          <button class='AcronymsButton' id="show-modal" :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>

          <router-link :to="{ name: 'HomePage' }">
            <button class='NavBackButton'></button>
          </router-link>
        </div>
      </div>
      <div class="pageContent">
        <slides-component :slide-data="slides" ></slides-component>
      </div>
  </div>
</template>

<script>
import AcronymsModal from '../modals/AcronymsModal.vue'
import SlidesComponent from "@/components/SlidesComponent";
export default {
  data () {
    return {
      acronymsState: false,
      slides:{
        1: {
          title: "Feedback",
          summary: "It is vital that anyone applying a manufacturing process receives feedback on how well the process is performing.  " +
              "This feedback needs to include:",
          points: [
            "How well is the process performing overall, Right First Time (RFT) or Defects Per Unit are examples of this.",
            "What are the main defects?",
            "Is performance improving or deteriorating?"
          ],
          image:"assets/images/Feedback/01_Feedback.jpg"
        },
        2:{
          title: "Process Performance",
          summary: "The simplest way of assessing process performance is by plotting the % of parts where the process is Right First Time (RFT).",
          points: [
              "RFT charts should be updated regularly, ideally daily.",
              "The chart should show data for a reasonable period of time so that trends can be seen.",
              "The easiest way of plotting RFT is to use inspection data, such as dimensional or NDE data.",
              "It is often best to produce several charts, covering each type of inspection",
              "Up to date performance charts must be displayed in the process area so that any changes or trends can be identified quickly."
          ],
          image:"assets/images/Feedback/02_Process_Performance.jpg"
        },
        3:{
          title: "What Are The Main Defects?",
          summary: "As well as understanding the process performance, it is important to understand the most common defects.  This is important for prioritising improvement effort. " +
              "A defect pareto chart is a simple way of showing the relative frequency of each defect type and can be invaluable for directing improvement effort",
          points: [],
          image:"assets/images/Feedback/03_Main_Defects.jpg"
        }
      },
      selectedSlide: 1
    }
  },
  created() {

  },
  methods: {
    changeView(sid){
      console.log("change to ", sid);
      this.selectedSlide = sid;
      console.log("change to ", this.selectedSlide);
    },
    btnClass(btn){
      if(this.selectedSlide == btn){
        return 'btn-outline-primary btn-active';
      }
      else {
        return 'btn-outline-primary';
      }
    },
    showAcronyms() {
      // Open Acronyms Modal 'LightOut' Box
      this.$modal.show(AcronymsModal, {}, {
        width: "100%",
        height: "auto"
      },{
        'before-close': () => { this.acronymsState = !this.acronymsState }
      });

      this.acronymsState = !this.acronymsState
    }
  },
  components:{
    SlidesComponent
  }

}
</script>
<style scoped>
.feedbackPageContainer{
  height: 100%;
  font-family: RRPioneer;
}
.pageContent{
  height: calc(100% - 200px);
  display: flex;
  flex-direction: column;
  margin: 50px;

}
</style>